export default __webpack_public_path__ + "media/images/logo_transparent_white-179f504d62175f68d67464d9f3e427a3.svg";